<template>
  <div class="reset-container">
    <h1>{{ $t("FormPasswordRestEmail.title") }}</h1>
    <p>{{ $t("FormPasswordRestEmail.description") }}</p>
    <el-form label-position="top" class="reset-form" @submit.prevent="handleSubmit">
      <el-form-item class="mt-12">
        <template #label>
          <label>
            {{ $t("FormPasswordRestEmail.email") }}
            <el-input
              v-model="email"
              autofocus
              :placeholder="$t('FormPasswordRestEmail.email')"
            />
          </label>
        </template>
      </el-form-item>
      <div class="flex justify-start mt-8">
        <el-button
          class="has-icon"
          :disabled="!isValidEmail || isLoading"
          :loading="isLoading"
          size="default"
          @click="validateToken"
        >
          <SvgIcon name="check-circle" />
          {{ $t("FormPasswordRestEmail.button") }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>
<script setup>
import { ref, computed, h } from "vue";
import { useUserStore } from "@/store/User";
import { ElNotification } from "element-plus";
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['success', 'redirect']);
const userStore = useUserStore();

const email = ref("");
const { t } = useI18n();

const props = defineProps({
  token: {
    type: String,
    required: true,
  },
});

const isValidEmail = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email.value.length > 0 && emailRegex.test(email.value);
});

const isLoading = ref(false);

const validateToken = async () => {
  try {
    isLoading.value = true;
    const response = await userStore.checkResetToken(props.token, email.value);
    if (response.valid) {
      emit('success', email.value);
    } else {
      throw new Error('Invalid token');
    }
  } catch (e) {
    ElNotification.error({
      title: t("FormPasswordRestEmail.errorTitle"),
      message: h(
      "div",
      { style: "color: teal; white-space: pre-line" },
      t("FormPasswordRestEmail.errorText")
    ),
    });
    redirectToForgotPassword();
  } finally {
    isLoading.value = false;
  }
};

const redirectToForgotPassword = () => {
  emit('redirect');
};

const handleSubmit = () => {
  if (isValidEmail.value && !isLoading.value) {
    validateToken();
  }
};
</script>

<style lang="postcss">
.login-container {
  @apply w-full;
}

@screen md {
  .login-container {
    @apply w-1/2 mx-auto;
  }
}

.login-form {
  @apply w-full;
}

@screen md {
  .login-form {
    @apply w-full;
  }
}
</style>